module.exports = __webpack_public_path__ + "static/media/ichiban-boshi.754b6fc6.png";